import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import '../shared.css';

const SalesManEdit = ({ match }) => {
  const recordId = match.params.id;
  const history  = useHistory();
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();
  const [formData, setFormData]         = useState({ Name: '' });
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchData('SalesManApi', `/SalesMan/${recordId}`, token)
      .then(res => { if (res.responseCode === '1111') setFormData(res.response_data); })
      .catch(console.error);
  }, [recordId, token]);

  const handleChange = e => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateData('SalesManApi', `${recordId}`, { ...formData, UpdatedBy: userId }, token);
      history.push('/SalesManIndex');
    } catch (err) { console.error(err); setErrorMessage('Failed to update.'); }
  };

  return (
    <div className="pg-container">
      <form onSubmit={handleSubmit}>
        <div className="pg-header">
          <h5 className="pg-title">Sales Man — Edit</h5>
          <div className="pg-header-actions">
            <button type="submit" className="pg-btn pg-btn-success"><DoneAllIcon /> Update</button>
            <Link to="/SalesManIndex" className="pg-btn pg-btn-danger"><CloseIcon /> Cancel</Link>
          </div>
        </div>
        {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
        <div className="pg-card">
          <div className="pg-form-grid" style={{ gridTemplateColumns: '1fr' }}>
            <div className="pg-field">
              <label className="pg-label">Sales Man Name <span className="req">*</span></label>
              <input className="pg-input" type="text" name="Name" placeholder="Enter sales man name"
                value={formData.Name} onChange={handleChange} required maxLength={100} />
            </div>
          </div>
        </div>
      </form>
      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
};

export default SalesManEdit;
